<template>
  <w-icon-wrapper icon-name='work-deputy-icon'>
    <path
      id='_56_Stellvertreter_Icon'
      d='M20.12,12.39a4,4,0,1,0-4.24,0,4.994,4.994,0,0,0-.93.45,8.087,8.087,0,0,0-4.49-3.49,4.994,4.994,0,1,0-4.86.04A8.09,8.09,0,0,0,0,17.08V24H24V18A6,6,0,0,0,20.12,12.39ZM5,5A3,3,0,1,1,8,8,3.009,3.009,0,0,1,5,5Zm9.15,17H2V17.08a6.075,6.075,0,0,1,11.4-2.93,5.87,5.87,0,0,1,.74,2.8.57.57,0,0,1,.01.13ZM18,7a2,2,0,1,1-2,2A2.006,2.006,0,0,1,18,7Zm4,15H16.15V17.08a8.314,8.314,0,0,0-.36-2.41A4,4,0,0,1,22,18Z'
      data-name='56 Stellvertreter_Icon'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDeputy' };
</script>
